import { InviteService } from "@buf/brevdev_devplane.connectrpc_es/devplaneapi/v1/invite_connect";
import { InvitationService } from "@buf/brevdev_devplane.connectrpc_es/devplaneapi/v1/invitation_connect";
import type { Timestamp } from "@bufbuild/protobuf";
import { OrganizationAccessLevel } from "@buf/brevdev_devplane.bufbuild_es/devplaneapi/v1/organization_access_pb";
import { createConnectClient } from "server/connect";

export type Invitation = {
  invitationId: string;
  invitationEmail: string;
  accessLevel: OrganizationAccessLevel;
  invitedAt?: Timestamp;
  expiresAt?: Timestamp;
};

const inviteClient = createConnectClient(InviteService);
const ncaInvitationClient = createConnectClient(InvitationService);

export const invitationClient = {
  acceptInvitation: ({ token }: { token: string }) =>
    ncaInvitationClient.acceptInvitation({ token }),

  acceptInviteFromLink: ({ token }: { token: string }) =>
    inviteClient.acceptInviteFromLink({ token }),

  createInvitation: (request: {
    emailAddress: string;
    organizationId: string;
  }) =>
    ncaInvitationClient.createInvitation({
      emailAddress: request.emailAddress,
      organizationId: request.organizationId,
    }),

  listInvitations: async ({
    organizationId,
    pending,
    expired,
  }: {
    organizationId: string;
    pending?: boolean;
    expired?: boolean;
  }) => {
    return ncaInvitationClient.listInvitations({
      organizationId,
      pending,
      expired,
    });
  },

  revokeInvitation: ({
    organizationId,
    invitationId,
  }: {
    organizationId: string;
    invitationId: string;
  }) =>
    ncaInvitationClient.deleteInvitation({
      organizationId,
      invitationId,
    }),
};
